<template>
  <el-container id="tab" class="ys-page">
    <el-main>
      <el-tabs type="border-card">
        <el-tab-pane ref="damage">
          <query-form @getQueryForm="getQueryForm" :billNo="billNo"></query-form>
          <orderEntering :from="queryItem" @getCustomColumn="getCustomColumn" :btn-power="btnPower"
            :power="{ tag, billNo, hideColumnList }"></orderEntering>
        </el-tab-pane>
        
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import queryForm from '@/components/invWare/invCheck/entire/queryForm.vue'
import orderEntering from '@/components/invWare/invCheck/entire/orderEntering.vue'
export default {
  name: "Inventory",
  props: ['billNo', 'tag'],
  components: {
    queryForm,
    orderEntering
  },
  data() {
    let billType = 'PKD'
    return {
      billType,
      activeName: 'damage',
      queryItem: {
        billType: billType
      },
      hideColumnList: [
        {
          "label": "品牌",
          "prop": "itemBrandName"
        },
        {
          "label": "品类",
          "prop": "brandTypeName"
        },
        {
          "label": "账面数折算小单位",
          "prop": "onhandQty"
        },
        {
          "label": "订单占用量",
          "prop": "onLoadQtyFormat"
        },
        {
          "label": "可用量",
          "prop": "availableQtyFormat"
        },
        {
          "label": "盘点数折算小单位",
          "prop": "realQty"
        },
        {
          "label": "条码",
          "prop": "invBarCode"
        },
        {
          "label": "生产日期",
          "prop": "productionDate"
        }
      ],
      defaultCheckedKeys: [],
      defaultDisabledKeys: [],
      btnPower: {}
    }
  },
  created() {
    this.getCustomColumn()
    this.getBtnPower()
    if (this.billNo) {
      this.getEditTabledata()
    }
  },
  methods: {
    async getBtnPower() {
      let menuID = 164
      const { data: res } = await this.$http.post('/Account/dataSearchVue/selectFunctionButtonAuth.html', this.Qs.stringify({ menuID }))
      res.result = JSON.parse(res.result)
      this.btnPower = JSON.parse(res.result.data)
      console.log(this.btnPower)
    },
    // 表单信息更改时触发，更新本组件的表单信息
    getQueryForm(e) {
      this.queryItem = { ...this.queryItem, ...e }
    },
    // 复制或编辑，根据billNo获取单据详情
    getEditTabledata() {
      this.$nextTick(async () => {
        let $table = this.$refs[this.activeName]?.$children[1]
        let $queryForm = this.$refs[this.activeName]?.$children[0]
        $queryForm.isCanEnter = true
        $table.tableLoading = true
        const { data: res } = await this.$http.post('/Account/dataSearchVue/selectBillDetail.html', this.Qs.stringify({
          billType: this.billType,
          billNo: this.billNo
        }))
        let { headInfo, itemList } = JSON.parse(JSON.parse(res.result).data)
        console.log({ headInfo, itemList });
        if (res.code != 'success') return this.$message.error(res.message)
        let inWarehouse = $queryForm.queryForm.inWarehouse.selected = { value: headInfo.warehouseID, text: headInfo.warehouseName, isOverOut: headInfo.isOverOut || 'Y' }
        $queryForm.queryForm.inWarehouse.list = $queryForm.queryForm.inWarehouse.list.filter(item => item.value != inWarehouse.value)
        $queryForm.queryForm.inWarehouse.list.unshift(inWarehouse)

        // let salesman = $queryForm.queryForm.salesman.selected = { value: headInfo.salesmanID, text: headInfo.salesmanName }
        // $queryForm.queryForm.salesman.list = $queryForm.queryForm.salesman.list.filter(item => item.value != salesman.value)
        // $queryForm.queryForm.salesman.list.unshift(salesman)

        let deliverUser = $queryForm.queryForm.deliverUser.selected = { value: headInfo.checkUserID, text: headInfo.checkUserName }
        $queryForm.queryForm.deliverUser.list = $queryForm.queryForm.deliverUser.list.filter(item => item.value != deliverUser.value)
        $queryForm.queryForm.deliverUser.list.unshift(deliverUser)
        // $queryForm.inWarehouseSelect()

        $queryForm.selectProductList = itemList.map(item => {
          item.isLess = false
          if(Number(item.realQty || 0) < Number(item.onLoadQty || 0)) { //盘点数小于占用量不可录入
            item.isLess = true
          }
          return item
        })
        /**
         * 这里是禁止库存调整、库存报损删除的代码，仅仅限制了商品选择的dialog
         */
        // $queryForm.defaultDisabledKeys = itemList
        this.getQueryForm($queryForm.queryItem)
        $table.sum.invCheckLossAmt = Number(headInfo.invCheckLossAmt || 0)
        $table.sum.invCheckProfitAmt = Number(headInfo.invCheckProfitAmt || 0)
        $table.sum.totalAmt = Number(headInfo.totalAmt || 0)
        $table.sum.billInvQty = Number(headInfo.billInvQty || 0)
        $table.sum.billMedQty = Number(headInfo.billMedQty || 0)
        $table.sum.billSalQty = Number(headInfo.billSalQty || 0)
        
        $table.isMultiplePeople = headInfo.isMultiplePeople

        if (this.invCheckWay == 'B') {
          this.defaultCheckedKeys = itemList.map(i => (
            {
              financialBrandID: i.financialBrandID,
              itemTypeID: i.itemTypeID,
            }
          ))
          this.defaultDisabledKeys = [...this.defaultCheckedKeys]
        }
        const result = await $table.addProductToOrder(itemList)
        if (result) $table.tableLoading = false
      })
    },
    // 获取自定义列详情
    getCustomColumn() {
      this.$nextTick(async () => {
        let $table = this.$refs[this.activeName]?.$children[1]
        $table.tableLoading = true
        const { data: res } = await this.$http.post('/Account/dataSearchVue/selectColumnByFuncCode.html', this.Qs.stringify({ funcCode: 208 }))
        $table.tableLoading = false
        if (res.code != 'success') return this.$message.error(res.message)
        let tempArr = JSON.parse(res.result)
        this.hideColumnList = this.hideColumnList.map(i => {
          tempArr.forEach(j => {
            if (i.prop == j.prop) {
              i['isShow'] = j.isShow
              i['id'] = j.id
            }
          })
          return i
        })
      })
    }
  }
};
</script>
<style lang="less" src="./assets/css/ys-page.less"></style>
<style scoped lang="less">
#tab {
  
  .el-main {
    padding: 0 0 0 6px;

    .el-tabs {
      height: calc(100% - 2px);
      box-shadow: none;
      ::v-deep .el-tabs__header {
        height: 0;
        .el-tabs__nav-wrap, .el-tabs__nav {
          height: 0;
        }
      }
      ::v-deep .el-tabs__item {
        height: 0;
      }

      ::v-deep .el-tabs__content {
        height: calc(100% - 24px);
        padding: 12px;

        .el-tab-pane {
          height: 100%;

          .el-card {
            border: none;
            .el-card__body {
              padding: 0 0 12px 0;
            }
          }
        }
      }
    }
  }
}

</style>